export default {
    buildPointsButtonData(pointsData, products, sku){
        if(pointsData === null && products && sku){
            // find sku
            for(let i = 0; i < products.length; i++){
                if(products[i].sku == sku){
                    console.log('buildPointsButtonData found ', products[i]);
                    pointsData = products[i].pointsPurchaseData;
                    break;
                }
            }
        }

        if(!pointsData){
            return {
                pointsBtn: null
            }
        }

        return {
            pointsBtn: {
                disabled: pointsData.disableButton,
                cost: pointsData.cost,
                hide: pointsData.hide,
                label: pointsData.btnLabel,
                noticeLabel: pointsData.noticeLabel,
                modalDescription: pointsData.modalDescription,
                availablePoints: pointsData.availablePoints,
                mode: '',
                loadingBar: 0,
            }
        };
    },
    updateDomContent(productInfoData){
        //console.log('updating dom content with info -> ', productInfoData);
        if(document.location.port == '8080' || !productInfoData || !productInfoData.name || !productInfoData.url){
            // Vue development mode or missing data
            return;
        }

        if(document.location.pathname == productInfoData.url){
            // URL matches, nothing to do (page just loaded)
            return;
        }
        // urls & tab name
        window.history.replaceState({url: productInfoData.url}, productInfoData.name, productInfoData.url);
        // metatags -> need code review here O_o
        const metaOgUrl = document.querySelector('meta[property="og:url"]');
        const metaOgImage = document.querySelector('meta[property="og:image"]');
        if (metaOgUrl && metaOgImage) {
            metaOgUrl.setAttribute('content', 'https://' + window.location.hostname + productInfoData.url);
            metaOgImage.setAttribute('content', productInfoData.image);
            const linkCanonical = document.querySelector('link[rel="canonical"]');
            if (linkCanonical) {
                linkCanonical.setAttribute('href', productInfoData.url);
            }
        }
    }
}